import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Fade,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import { AddBox } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';

import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../../../components/snackBar/snakbar';
import DeleteModal from '../../../../../components/modals/DeleteModal';
import { useSelector } from 'react-redux';
import { useThemes } from '../../../../../components/Theme/theme';
import useSaveModalShortcut from '../../../Components/useSaveModalShortcut';
import {
  useCreateBusinessOptionsMutation,
  useCreateIndustryOptionsMutation,
  useDeleteBusinessOptionsMutation,
  useLazyGetBusinessOptionsQuery,
  useLazyGetIndustryOptionsQuery,
} from '../../../../../features/CompanySetup/Api/BuzIndType.api';

const AddTypeModal = ({ open, setOpen, type, options, setState, state, companyId }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: type === 'IndustryType' ? '22%' : '50%',
    bgcolor: 'background.paper',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    outline: 'none',
    minWidth: '300px',
    // height: "60%",
  };
  console.log(state, 'statekkk');
  const [rows, setRows] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editedRow, setEditedRow] = useState({
    id: 0,
    [type.toLowerCase()]: '',
    editable: false,
    new: false,
  });
  const textref = useRef(null);
  const buttonRef = useRef(null);
  const [editClick, setEditClick] = useState(false);
  const [editData, setEditData] = useState('');
  const textFieldRefs = useRef([]);
  const buttonRefclose = useRef();
  const editBtnref = useRef();
  const modalClose = useRef();
  const [businessTypeFn, { data: BizData }] = useLazyGetBusinessOptionsQuery();
  const [IndustryTypeFn, { data: IndData }] = useLazyGetIndustryOptionsQuery();
  const [createbusinessType] = useCreateBusinessOptionsMutation();
  const [createindustryType] = useCreateIndustryOptionsMutation();
  // console.log(data, 'bbbbbbbbbbbbb');

  const TableHeaders = [
    {
      id: 'S. No',
      label: 'Sl. No',
      width: '50px',
      align: 'center',
    },
    {
      id: 'businessType',
      label: `${type}`,
      width: '150px',
      align: 'center',
    },
    {
      id: 'action',
      label: 'Action',
      width: '100px',
      align: 'center',
    },
  ];
  const companyDetails = useSelector((state) => state?.companyReducer?.companyDetails);

  const listTypes = async () => {
    setBackdropOpen(true);
    if (type === 'BusinessType') {
      try {
        const busData = await businessTypeFn(null, true);

        const newBusinessOptionsArr = busData?.data ? [...busData.data] : [];
        setRows(newBusinessOptionsArr);

        const optionsForParent = [...newBusinessOptionsArr];
        optionsForParent.push({
          businesstype: 'Add Business Type',
          value: 'Add Business Type',
          isactive: 0,
          restrictedflag: 1,
          id: 0,
        });
        setState((prev) => {
          const newIndustryType = newBusinessOptionsArr.filter((item) => item.isactive === 1).map((item) => item.businesstype);

          const merged = [...prev.formone.buisnessType, ...newIndustryType];

          // Use a Set to remove duplicates
          const uniqueMerged = Array.from(new Set(merged));

          return {
            ...prev,
            formone: {
              ...prev.formone,
              buisnessType: uniqueMerged,
            },
          };
        });
      } catch (error) {
        console.log('error', error);
      }
    } else if (type === 'IndustryType') {
      try {
        const indData = await IndustryTypeFn(null, true);
        const newIndustryOptionsArr = indData?.data;
        setRows([...newIndustryOptionsArr]);
        newIndustryOptionsArr.push({
          industrytype: 'Add Industry Type',
          value: 'Add Industry Type',
          isactive: 0,
          restrictedflag: 1,
          id: 0,
        });
        // setState((prev) => ({
        //   ...prev,
        //   formone: {
        //     ...prev.formone,
        //     industryType: newIndustryOptionsArr
        //       .filter((item) => item.isactive === 1)
        //       .map((item) => item.industrytype),
        //   },
        // }));
        setState((prev) => {
          const newIndustryType = newIndustryOptionsArr.filter((item) => item.isactive === 1).map((item) => item.industrytype);

          const merged = [...prev.formone.industryType, ...newIndustryType];

          // Use a Set to remove duplicates
          const uniqueMerged = Array.from(new Set(merged));

          return {
            ...prev,
            formone: {
              ...prev.formone,
              industryType: uniqueMerged,
            },
          };
        });
      } catch (error) {
        console.log('error', error);
      }
    }
    setBackdropOpen(false);
  };
  useEffect(() => {
    if (BizData) {
      setRows(BizData);
    }
    // Serialize data for deep comparison - detects changes in nested objects
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BizData]);
  useEffect(() => {
    if (IndData) {
      // setRows(Array.isArray(BizData) ? [...BizData] : BizData);
      setRows(IndData);
    }
    // Serialize data for deep comparison - detects changes in nested objects
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IndData]);
  // console.log(options, 'option');
  // console.log(data, 'datadata');
  function addNewRow(e) {
    e.preventDefault();
    // console.log("new row");
    if (editData) {
      // listTypes();
      // const opts = options.filter(
      //   (op) => op.businesstype !== "Add Business Type"
      // );
      // setRows(opts);
      setEditData('');
    }
    if (editedRow[type.toLowerCase()]?.trim() === '' && editedRow.editable === true) {
      showErrorSnackbar(`empty ${type} cannot be added`);
      textref?.current?.focus();
    } else if (editedRow[type.toLowerCase()]?.trim() !== '' && editedRow.editable === true) {
      setEditedRow({
        id: rows.length + 1,
        [type.toLowerCase()]: editedRow[type.toLowerCase()],
        editable: true,
        new: true,
      });
    } else {
      setEditedRow({
        id: rows.length + 1,
        [type.toLowerCase()]: '',
        editable: true,
        new: true,
      });
    }
  }
  useEffect(() => {
    listTypes();
  }, [open]);
  console.log(editedRow, 'editedRow');
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
      setEditedRow({
        id: rows.length + 1,
        [type.toLowerCase()]: editedRow[type.toLowerCase()],
        editable: false,
        new: false,
      });
    }
  };

  const closeNewRow = () => {
    setEditedRow({
      ...editedRow,
      editable: false,
    });
  };

  const handleEditChange = (e, column) => {
    // console.log(textFieldRef, "textfiels");
    let value = e.target.value;
    if (type === 'BusinessType') {
      setRows(
        rows.map((row) => {
          return row.businesstypeid === column.businesstypeid ? { ...row, businesstype: value } : row;
        })
      );
    }
    if (type === 'IndustryType') {
      setRows(rows.map((row) => (row.industrytypeid === column.industrytypeid ? { ...row, industrytype: value } : row)));
    }
  };
  console.log(rows, 'rows');
  console.log(type, 'type');
  console.log(editData, 'rows');

  const handleEdit = async (column) => {
    console.log(editData, 'editData');
    console.log(column, 'column formone');
    const filteredTypes = rows
      .filter((typ) => typ?.businesstypeid !== column?.businesstypeid || typ?.industrytypeid !== column?.industrytypeid)
      .map((itm) => itm?.industrytype || itm?.businesstype);
    console.log(filteredTypes, 'filteredTypes');
    console.log(column?.businesstype, 'column?.businesstype filteredTypes');
    setBackdropOpen(true);
    if (type === 'BusinessType' && column.businesstype.trim() !== '') {
      if (column.businesstype === editData.businesstype) {
        setRows(rows.map((row) => (row.businesstypeid === column.businesstypeid ? { ...row, editable: false } : row)));
        setEditData('');
      } else if (!filteredTypes.includes(column?.businesstype.trim())) {
        try {
          const businessTypeInputs = {
            businesstype: column?.businesstype.replace(/\s+/g, ' ').trim(),
            businesstypeid: column?.businesstypeid,
            companyid: companyId,
            isactive: column.isactive,
            // enteredtimestamp: 0,
            expiredtimestamp: 0,
            lastupdatedby: companyDetails?.relatedcompanydetailsnew[0]?.lastupdatedby,
            restrictedflag: 0,
          };
          const res = await createbusinessType({
            businessTypeInputs,
          });

          setState((prev) => ({
            ...prev,
            formone: {
              ...prev.formone,
              buisnessType: prev.formone.buisnessType.map((item) => (item === editData.businesstype ? column.businesstype : item)),
            },
          }));

          showSuccessSnackbar('Business Type updated');
          setEditData('');
          setEditClick(false);
        } catch (error) {
          console.log('error', error);
        }
        setRows(rows.map((row) => (row.businesstypeid === column.businesstypeid ? { ...row, editable: false } : row)));
      } else {
        showWarningSnackbar('Business Type already exists');
      }
    } else if (type === 'IndustryType' && column.industrytype.trim() !== '') {
      if (column.industrytype.trim() === editData.industrytype.trim()) {
        setRows(rows.map((row) => (row.industrytypeid === column.industrytypeid ? { ...row, editable: false } : row)));
        setEditData('');
      } else if (!filteredTypes.includes(column?.industrytype.trim())) {
        try {
          const industryTypeInputs = {
            industrytype: column?.industrytype.replace(/\s+/g, ' ').trim(),
            industrytypeid: column?.industrytypeid,
            isactive: column.isactive,
            companyid: companyId,
            // enteredtimestamp: 0,
            expiredtimestamp: 0,
            lastupdatedby: companyDetails?.relatedcompanydetailsnew[0]?.lastupdatedby,
            restrictedflag: 0,
          };
          const res = await createindustryType({ industryTypeInputs });

          console.log(editData, 'editData');
          console.log(column, 'column');
          setState((prev) => ({
            ...prev,
            formone: {
              ...prev.formone,
              industryType: prev.formone.industryType.map((item) => (item === editData.industrytype ? column.industrytype : item)),
            },
          }));
          console.log(state, 'state');
          showSuccessSnackbar('Industry Type updated');
          // listTypes();
          setEditData('');
          setEditClick(false);
        } catch (error) {
          console.log('error', error);
        }
        setRows(rows.map((row) => (row.industrytypeid === column.industrytypeid ? { ...row, editable: false } : row)));
      } else {
        showWarningSnackbar('Industry Type already exists');
      }
    } else {
      showWarningSnackbar('Cannot save empty type');
    }
    // scrollToBottom();

    setBackdropOpen(false);
  };
  const modalContentRef = useRef(null);
  const scrollToBottom = () => {
    setTimeout(() => {
      if (modalContentRef.current) {
        modalContentRef.current.scrollTo({
          top: modalContentRef.current.scrollHeight,
          behavior: 'smooth', // Smooth scroll animation
        });
      }
    }, 350);
  };

  const successType = () => {
    setEditedRow({
      [type.toLowerCase()]: editedRow.businesstype
        ? editedRow.businesstype.replace(/\s+/g, ' ').trim()
        : editedRow.industrytype.replace(/\s+/g, ' ').trim(),
      editable: false,
      new: false,
      id: rows.length + 1,
    });
    // listTypes();
  };

  const { theme } = useThemes();

  const saveChanges = async () => {
    setEditData('');
    setBackdropOpen(true);
    if (editedRow?.businesstype?.trim() === '' || editedRow?.industrytype?.trim() === '') {
      showSuccessSnackbar('No Type saved');
    } else {
      const duplicatCheck = rows.filter(
        (item) =>
          item?.businesstype?.toLowerCase().trim() ===
          (editedRow?.businesstype?.toLowerCase().trim() || editData?.businesstype?.toLowerCase().trim())
      );
      const duplicatCheck2 = rows.filter(
        (item) =>
          item?.industrytype?.toLowerCase().trim() ===
          (editedRow?.industrytype?.toLowerCase().trim() || editData?.industrytype?.toLowerCase().trim())
      );
      console.log(duplicatCheck, 'duplicatCheck');
      if ((type === 'BusinessType' && duplicatCheck.length > 0) || (type === 'IndustryType' && duplicatCheck2.length > 0)) {
        const typeCheck = type === 'BusinessType' ? 'Business Type' : 'Industry Type';
        showWarningSnackbar(`${typeCheck} already exists`);
        setBackdropOpen(false);
        return;
      } else if (type === 'BusinessType' && editedRow?.businesstype?.trim() !== '') {
        try {
          setBackdropOpen(true);
          const data = {
            businesstype: editedRow.businesstype.replace(/\s+/g, ' ').trim(),
          };
          const businessTypeInputs = {
            businesstype: editedRow.businesstype.replace(/\s+/g, ' ').trim(),
            businesstypeid: 0,
            companyid: companyId,
            // enteredtimestamp: 0,
            expiredtimestamp: 0,
            lastupdatedby: companyDetails?.relatedcompanydetailsnew[0]?.lastupdatedby,
            restrictedflag: 0,
            isactive: 0,
          };

          const dropdownRes = await createbusinessType({ businessTypeInputs });

          if (dropdownRes.data.createbusinessType.statuscode === 'ERROR') {
            showErrorSnackbar(dropdownRes.data.createbusinessType.statusmessage);
          } else {
            setState((prev) => ({
              ...prev,
              formone: {
                ...prev.formone,
                buisnessType: [...prev.formone.buisnessType, editedRow.businesstype.replace(/\s+/g, ' ').trim()],
              },
            }));
            showSuccessSnackbar('Business Type Added');
            // RTK Query automatically invalidates and refetches, but we need to update local state
            // listTypes();
            scrollToBottom();
            successType();
          }
        } catch (error) {
          console.log('error', error);
        }
      } else if (type === 'IndustryType' && editedRow?.industrytype?.trim() !== '') {
        try {
          const data = {
            industrytype: editedRow.industrytype.replace(/\s+/g, ' ').trim(),
          };
          const industryTypeInputs = {
            industrytype: editedRow.industrytype.replace(/\s+/g, ' ').trim(),
            industrytypeid: 0,
            companyid: companyId,
            // enteredtimestamp: 0,
            expiredtimestamp: 0,
            lastupdatedby: companyDetails?.relatedcompanydetailsnew[0]?.lastupdatedby,
            restrictedflag: 0,
            isactive: 0,
          };

          const dropdownRes = await createindustryType({ industryTypeInputs });

          if (dropdownRes.data.createindustryType.statuscode === 'ERROR') {
            showErrorSnackbar(dropdownRes.data.createindustryType.statusmessage);
          } else {
            setState((prev) => ({
              ...prev,
              formone: {
                ...prev.formone,
                industryType: [...prev.formone.industryType, editedRow.industrytype.replace(/\s+/g, ' ').trim()],
              },
            }));
            showSuccessSnackbar('Industry Type Added');
            // RTK Query automatically invalidates and refetches, but we need to update local state
            // listTypes();
            scrollToBottom();
            successType();
          }
        } catch (error) {
          console.log('error', error);
        }
      }
    }
    setEditedRow({
      id: 0,
      [type.toLowerCase()]: '',
      editable: false,
      new: false,
    });
    setBackdropOpen(false);
  };

  useEffect(() => {
    if (editedRow.editable && textref.current) {
      if (textref.current) {
        textref.current.value = '';
        textref.current.focus();
      }
      // if (textFieldRef.current) {
      //   textFieldRef.current.focus();
      // }
    }
  }, [editedRow.editable]);

  useEffect(() => {
    closeNewRow();
    if (editClick === true && textFieldRefs.current) {
      textFieldRefs?.current?.focus();
      setEditClick(false);
    }
  }, [editClick]);
  const handleDeleteBtnClick = async (column) => {
    if (type === 'BusinessType') {
      const businessTypeInputs = {
        businesstype: column?.businesstype.replace(/\s+/g, ' ').trim(),
        businesstypeid: column?.businesstypeid,
        companyid: companyId,
        isactive: column.isactive,
        // enteredtimestamp: 0,
        expiredtimestamp: Math.floor(Date.now() / 1000),
        lastupdatedby: companyDetails?.relatedcompanydetailsnew[0]?.lastupdatedby,
        restrictedflag: 0,
      };

      try {
        const res1 = await createbusinessType({ businessTypeInputs });

        // const res = await API.graphql(
        //   graphqlOperation(deleteBusinessTypeDropdown, {
        //     BusinessTypeID: column.BusinessTypeID,
        //   })
        // );
        setState((prev) => ({
          ...prev,
          formone: {
            ...prev.formone,
            buisnessType: [...prev.formone.buisnessType.filter((biz) => biz !== column?.businesstype)],
          },
        }));
        showSuccessSnackbar('Business type Deleted');
      } catch (error) {
        console.log('error', error);
      }
    } else if (type === 'IndustryType') {
      try {
        const industryTypeInputs = {
          industrytype: column?.industrytype.replace(/\s+/g, ' ').trim(),
          industrytypeid: column?.industrytypeid,
          isactive: column.isactive,
          companyid: companyId,
          // enteredtimestamp: 0,
          expiredtimestamp: Math.floor(Date.now() / 1000),
          lastupdatedby: companyDetails?.relatedcompanydetailsnew[0]?.lastupdatedby,
          restrictedflag: 0,
        };
        const res = await createindustryType({
          industryTypeInputs,
        });

        // const res = await API.graphql(
        //   graphqlOperation(deleteIndustryTypeDropdown, {
        //     IndustryTypeID: column.IndustryTypeID,
        //   })
        // );
        setState((prev) => ({
          ...prev,
          formone: {
            ...prev.formone,
            industryType: [...prev.formone.industryType.filter((biz) => biz !== column?.industrytype)],
          },
        }));
        showSuccessSnackbar('Industry type Deleted');
      } catch (error) {
        console.log('error', error);
      }
    }
  };
  const handleNewChange = (e) => {
    let value = e.target.value;
    console.log(type, value);
    setEditedRow({
      [type.toLowerCase()]: value,
      editable: true,
      new: true,
      id: rows.length + 1,
    });
  };
  const handleNewEnterKey = (event) => {
    if (event.key === 'Enter') {
      saveChanges();
      // handleBlur();
    }
  };

  const handleEditEnterClick = (event, column) => {
    if (event.key === 'Enter') {
      handleEdit(column);
    }
  };
  const shouldTriggerSave = !!editBtnref?.current;
  useSaveModalShortcut(() => {
    if (shouldTriggerSave) {
      editBtnref.current.click();
    } else {
      saveChanges();
    }
  });
  return (
    <Box id={open ? 'AddTypeAccountModal' : ''}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        onClose={handleClose}

        // sx={{
        //   width: "60vw",
        //   height: "70vh",
        // }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                }}
              >
                Add {type}
              </Typography>
              <IconButton aria-label="delete" ref={modalClose} onClick={handleClose}>
                <CloseIcon sx={{ color: '#fff' }} />
              </IconButton>
            </Box>

            <Paper
              sx={{
                // backgroundColor: "white",
                padding: '15px',
              }}
            >
              <TableContainer
                ref={modalContentRef}
                className="custom-scrollbar"
                sx={{
                  maxHeight: '70vh',
                  overflowY: 'auto',

                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'primary.main',
                  },
                }}
              >
                <TableContainer stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {TableHeaders.map((column) => {
                        return (
                          <TableCell
                            align={column?.align}
                            sx={{
                              width: column.width,
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                            key={column.id}
                          >
                            {column.label}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      '.MuiTableCell-root': {
                        backgroundColor: 'transparent !important',
                        padding: '8px 5px',
                        fontSize: '15px',
                      },
                    }}
                  >
                    <>
                      {editedRow.editable && (
                        <TableRow key={editedRow.id} hover role="checkbox" id="yourTableRowId" className="TableCellBorder">
                          <TableCell sx={{ width: '50px' }}></TableCell>
                          <TableCell sx={{ width: '150px' }}>
                            <TextField
                              size="small"
                              inputRef={textref}
                              required={true}
                              type="text"
                              error={!editedRow?.businesstype && !editedRow?.industrytype}
                              value={editedRow?.businesstype ? editedRow?.businesstype : editedRow?.industrytype || ''}
                              onChange={(e) => handleNewChange(e)}
                              // onKeyDown={(e) => handleNewEnterKey(e)}
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  buttonRefclose.current.focus();
                                }
                              }}
                              // onBlur={saveChanges}
                            />
                          </TableCell>

                          <TableCell align="center">
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              {editedRow.editable && (
                                <Box>
                                  <IconButton
                                    disableRipple
                                    aria-label="delete"
                                    ref={buttonRefclose}
                                    sx={{
                                      margin: '0px 2px',
                                      padding: '5px',
                                      backgroundColor: '#fbc7c78c',
                                      '&:focus': {
                                        backgroundColor: '#d5d5d5',
                                      },
                                    }}
                                    onClick={saveChanges}
                                  >
                                    <DoneIcon
                                      sx={{
                                        fontSize: `15px`,
                                        color: '#6096d9',
                                      }}
                                    />
                                  </IconButton>
                                  <IconButton
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: '0px 2px',
                                      padding: '5px',
                                      backgroundColor: '#fbc7c78c',
                                      '&:focus': {
                                        backgroundColor: '#d5d5d5',
                                      },
                                    }}
                                    onClick={closeNewRow}
                                  >
                                    <CloseIcon
                                      sx={{
                                        fontSize: '15px',
                                        color: '#eb6a6a',
                                      }}
                                    />
                                  </IconButton>
                                </Box>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                      {rows?.length > 0 ? (
                        rows.map((column, index) => {
                          return (
                            <TableRow
                              className="TableCellBorder"
                              hover
                              role="checkbox"
                              key={column?.id}
                              sx={
                                {
                                  // backgroundColor: "#fff",
                                }
                              }
                            >
                              <TableCell>{index + 1}</TableCell>
                              <TableCell align="center">
                                {(type === 'BusinessType' && column['businesstypeid'] === editData['businesstypeid']) ||
                                (type === 'IndustryType' && column['industrytypeid'] === editData['industrytypeid']) ? (
                                  <TextField
                                    id="itemType"
                                    name="itemType"
                                    size="small"
                                    inputRef={textFieldRefs}
                                    required={true}
                                    type="text"
                                    value={column?.businesstype ? column?.businesstype : column?.industrytype}
                                    onChange={(e) => handleEditChange(e, column)}
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        editBtnref.current.focus();
                                      }
                                    }}

                                    // onBlur={(}
                                  />
                                ) : column?.businesstype ? (
                                  column?.businesstype
                                ) : (
                                  column?.industrytype
                                )}
                              </TableCell>
                              <TableCell align="right">
                                {(type === 'BusinessType' && column['businesstypeid'] === editData['businesstypeid']) ||
                                (type === 'IndustryType' && column['industrytypeid'] === editData['industrytypeid']) ? (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: '0px 2px',
                                        padding: '5px',
                                        backgroundColor: '#fbc7c78c',
                                        '&:focus': {
                                          backgroundColor: '#d5d5d5',
                                        },
                                      }}
                                      ref={editBtnref}
                                      onClick={() => handleEdit(column)}
                                      // onBlur={listTypes}
                                    >
                                      <DoneIcon
                                        sx={{
                                          fontSize: `15px`,
                                          color: '#6096d9',
                                        }}
                                      />
                                    </IconButton>
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: '0px 2px',
                                        padding: '5px',
                                        backgroundColor: '#fbc7c78c',
                                        '&:focus': {
                                          backgroundColor: '#d5d5d5',
                                        },
                                      }}
                                      onClick={() => {
                                        setEditData('');
                                        // listTypes();
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{
                                          fontSize: '15px',
                                          color: '#eb6a6a',
                                        }}
                                      />
                                    </IconButton>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: '0px 2px',
                                        padding: '5px',
                                        backgroundColor: '#b1d1f97d',
                                      }}
                                      onClick={() => {
                                        setEditData(column);
                                        setEditClick(true);
                                      }}
                                    >
                                      <EditIcon
                                        sx={{
                                          fontSize: `15px`,
                                          color: '#6096d9',
                                        }}
                                      />
                                    </IconButton>
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: '0px 2px',
                                        padding: '5px',
                                        backgroundColor: '#fbc7c78c',
                                      }}
                                      onClick={() => {
                                        setDeleteOpen(column);
                                      }}
                                    >
                                      <DeleteIcon
                                        sx={{
                                          fontSize: '15px',
                                          color: '#eb6a6a',
                                        }}
                                      />
                                    </IconButton>
                                  </Box>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell align="center" colSpan={7}>
                            No Items Found
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                    <Backdrop
                      sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={backdropOpen}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </TableBody>
                </TableContainer>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ dispaly: 'flex', justifyContent: 'space-between' }}>
                  <Button
                    variant="outlined"
                    disableRipple
                    disableElevation
                    size="small"
                    ref={buttonRef}
                    disabled={editData}
                    onClick={(e) => addNewRow(e)}
                    startIcon={<AddBox />}
                    sx={{
                      fontSize: '12px',
                      marginTop: '15px',
                    }}
                  >
                    Add New Line
                  </Button>
                </Box>
              </Box>
            </Paper>

            {/* <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flex: 1,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={(event) => {
                event?.preventDefault();
                saveChanges();
              }}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              ADD
            </LoadingButton>
          </Box> */}

            {deleteOpen !== false ? (
              <DeleteModal
                open={deleteOpen !== false}
                setOpen={setDeleteOpen}
                func={() => {
                  handleDeleteBtnClick(deleteOpen);
                }}
                text={type === 'IndustryType' ? 'Industry Type' : 'Business Type'}
              />
            ) : null}
            <Backdrop open={backdropOpen} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default AddTypeModal;
